<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="9"
    viewBox="0 0 12 9"
  >
    <path
      d="M4.04167 8.9375L0 4.91667L1.0625 3.83333L4.04167 6.8125L10.8125 0.0625L11.875 1.125L4.04167 8.9375Z"
    />
  </svg>
</template>
